import { prepareFormDataId } from '@/utils/form/prepareFormDataId'

export function prepareBuildingRegisterFormData (data) {
  const keyList = ['director']
  return prepareFormDataId(data, keyList)
}
